export default "__VITE_ASSET__B9K2m8kR__"